import { useMemo as t } from "react";
import { l as p } from "./lodash-fd177a50.js";
import "./_commonjsHelpers-10dfc225.js";
const r = (o) => t(() => p.isEmpty(o) ? void 0 : () => o, [o]);
export {
  r as default
};
